import config from '@quno/patient-journey/config';

export const getCountry = async (): Promise<string> => {
  const result = await (await fetch('/api/location')).json();
  return result.country || config.defaults.country;
};
